import { Component, Input, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { SearchBaseResponse } from "@tcm-modules/tcm-core.module";
import { Task } from "../../../../../helpers/task";

@Component({
    selector: 'tcm-main-search-layout',
    templateUrl: './tcm-main-search-layout.component.html',
    styleUrls: ['./tcm-main-search-layout.component.scss'],
    standalone: false
})
export class TcmMainSearchLayoutComponent implements AfterViewInit {
    @Input() isLoading: boolean = false;
    @Input() hideCommands: boolean = false;
    @Input() titleKey: string;    
    @Input() showPrint: boolean = true;

    @Input() useExport: boolean = true;
    @Input() useGlobalSearch: boolean = true;
    @Input() useAdvancedSearch: boolean = true;

    @Input() showAdvanced: boolean = false;   

    @Input() searchTerm: string;
    @Output() searchTermChange = new EventEmitter<string>();
    
    @Input() globalSearchPlaceholder = 'Screens.Appointments.Search.Actions.GlobalSearchPlaceholder';

    @Output() print = new EventEmitter<boolean>();
    @ViewChild('rightSideBarContainer', { static: true }) rightSideBarContainer: ElementRef<HTMLElement>; 

    async ngAfterViewInit() {
        await this.onShowAdvancedChange();
    }

    async onShowAdvancedChange() {
        if(this.showAdvanced) {
            await Task.delay(600);
        }
        
        if(this.showAdvanced) {
            this.rightSideBarContainer.nativeElement.classList.add('omit-overflow');
        }
        else{
            this.rightSideBarContainer.nativeElement.classList.remove('omit-overflow');
        }
    }
}
